<div class="ib-layout__section">
    <div class="ib-box ib-box--medium ib-box--bordered ib-box--unfocused-low">
        <span class="ib-heading ib-heading--type-4 ib-heading--type-4--responsive u-mb-small">{{'SEATS_DISRUPTION_OPTION_3_TITLE' | translate}}</span>
        <div class="ib-info-icon__description ib-on-hold-grey-box__description u-mb-xsmall">
            <ul>
                <li class="ib-list__item">{{'SEATS_DISRUPTION_OPTION_3_SUBTITLE' | translate}}</li>
            </ul>
        </div>
        <a class="ib-link" (click)="openRefundModal()" title="{{'MMB_DISRUPTION_REFUND_AREA_TEXT' | translate}}">{{'MMB_DISRUPTION_REFUND_AREA_TEXT' | translate}}</a>
    </div>
</div>